import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Route, Redirect } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const AdminRoute = ({ children, ...rest }) => {
    const { user, admin, isLoad } = useAuth();
    if (isLoad) {
        return <div className="text-center my-5">
            <Spinner animation="border" variant="info" />
        </div>
    }
    return (
        <Route
            {...rest}
            render={({ location }) =>
                (admin || user?.email) ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
};

export default AdminRoute;